import type { IdentityUserManager } from './userManager';

export const getUserManager = () =>
    // eslint-disable-next-line no-underscore-dangle
    (window as any).__IdentityUserManager__ as IdentityUserManager | null
;

export const setUserManager = (manager: IdentityUserManager) => {
    // eslint-disable-next-line no-underscore-dangle
    (window as any).__IdentityUserManager__ = manager;
};
